import React from 'react';
import Reflux from 'reflux';
import AlertBar from 'shared/components/misc/alertBar.jsx';
import ReadOnlyStore from 'flux/stores/ReadOnlyStore';
import EventShowListActions from 'flux/actions/EventShowListActions';

/**
 * Read-Only alert bar
 */
export default React.createClass({
  mixins: [Reflux.connect(ReadOnlyStore, 'readOnly')],

  displayName: 'ReadOnlyAlertBar',

  render() {
    if (!this._isVisible()) return null;

    return (
      <AlertBar
        type="danger"
        message={this.state.readOnly.get('message')}
        actionButton={this._getRestoreButton()}
        dismissible
        onDismiss={this._handleClose}
      />
    );
  },

  _handleClose() {
    this.setState({ hidden: true });
  },

  _isVisible() {
    return !this.state.hidden && this.state.readOnly.get('readOnly')
      ? true
      : false;
  },

  _getRestoreButton() {
    if (!this.state.readOnly.has('showParams')) return null;

    return (
      <button
        className={'btn restore-show-btn'}
        onClick={this._handleRestoreClick}
      >
        Restore
      </button>
    );
  },

  _handleRestoreClick() {
    const showParams = this.state.readOnly.get('showParams');

    const { teamId, eventId, showId, displayType } = showParams;

    EventShowListActions.restore(teamId, eventId, showId, displayType);
  },
});
